import { Suspense, lazy } from "react";
import { Navigate, Route } from "react-router-dom";
import PageLoader from "components/PageLoader";
import routesPaths from "routes/routesPaths";
import { SurveyChose } from "modules/survey/ui/pages/surveyChose";

import SurveyRootRoute from "./SurveyRootRoute";

const SurveyCover = lazy(() =>
  import("../../ui/pages/SurveyCover").then((result) => ({
    default: result.SurveyCover,
  })),
);

const SurveyQuestion = lazy(() =>
  import("../../ui/pages/SurveyQuestion").then((result) => ({
    default: result.SurveyQuestion,
  })),
);

const SurveyEnd = lazy(() =>
  import("../../ui/pages/SurveyEnd").then((result) => ({
    default: result.SurveyEnd,
  })),
);

const SurveyRoutes = (
  <Route path={routesPaths.survey} element={<SurveyRootRoute />}>
    <Route
      path={routesPaths.survey}
      index
      element={
        <Suspense fallback={<PageLoader />}>
          <SurveyChose />
        </Suspense>
      }
    />
    <Route
      path='end'
      element={
        <Suspense fallback={<PageLoader />}>
          <SurveyEnd />
        </Suspense>
      }
    />
    <Route
      path=':surveyID'
      element={
        <Suspense fallback={<PageLoader />}>
          <SurveyCover />
        </Suspense>
      }
    />
    <Route
      path=':surveyID/questions/:questionID'
      element={
        <Suspense fallback={<PageLoader />}>
          <SurveyQuestion />
        </Suspense>
      }
    />
    <Route path='*' element={<Navigate replace to='' />} />
  </Route>
);

export default SurveyRoutes;
